<template>
	<button class="btn btn-icon btn-icon-open">
		<svgicon :name="icon" :fill="false" class="arrow"/>
		<span>
			<slot/>
		</span>
	</button>
</template>

<script>
export default {
	props: [
		'icon'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonIconOpen.vue